module.exports = __webpack_public_path__ + "static/img/7738.de41b18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/7738.jpg
// module id = zJJR
// module chunks = 0